import type { ApolloCache } from '@apollo/client';

interface RemoveFromCache {
  id: string;
  __typename?: string;
}

export function removeFromCache({ id, __typename }: RemoveFromCache): (cache: ApolloCache) => void {
  return function update(cache: ApolloCache) {
    const cachedId = cache.identify({ id, __typename });
    if (cachedId) {
      cache.evict({ id: cachedId });
      cache.gc();
    }
  };
}
